import InviteVM from './invite-vm';
export default {
  init: function(node){
    var validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;

    ko.applyBindingsWithValidation(new InviteVM(), node, validationOptions);
  }
};
